import { IndicatorLabel, Typography } from "@codat/orchard-ui";
import { IndicatorLabelColor } from "@codat/orchard-ui/dist/es/components/IndicatorLabel/IndicatorLabel";
import { WhatsNewFeedItem } from "hooks/useParseWhatsNewFeed";
import React from "react";
import { formatDateAndTimeWithShortString } from "utils/formatDate";

import styles from "./ChangelogItem.module.css";

const ChangelogItem = ({
  description,
  date,
  tags,
}: Omit<WhatsNewFeedItem, "link">) => {
  const getTagColor = (label: string): IndicatorLabelColor => {
    switch (label.toLowerCase().split(" ").join("-")) {
      case "deprecation":
        return "warning";
      case "action-required":
        return "warning";
      case "portal":
        return "action";
      case "link":
        return "neutral";
      case "assess":
        return "positive";
      case "sync-for-commerce":
        return "positive";
      case "sync-for-expenses":
        return "positive";
      default:
        return "interface";
    }
  };

  const tagInfo: { label: string; color: IndicatorLabelColor }[] =
    tags
      ?.map((tag) => {
        const label = tag.trim();
        return {
          label,
          color: getTagColor(label),
        };
      })
      .slice(0, 1) || [];

  return (
    <div className={styles.changelogItem}>
      <div className={styles.header}>
        {tagInfo.map((tag) => (
          <IndicatorLabel
            label={tag.label}
            color={tag.color}
            key={tag.label}
            className={styles.indicatorLabel}
            data-testid={`${tag.label.toLowerCase()}-${
              tag.color
            }-indicator-label`}
          />
        ))}
        <Typography as="p" variant="body_sm" className={styles.date}>
          {date ? formatDateAndTimeWithShortString(date) : "-"}
        </Typography>
      </div>
      <Typography as="p" variant="body_sm" className={styles.description}>
        {description}
      </Typography>
    </div>
  );
};

export default ChangelogItem;
